class FakeUsers {
  async all({ condition, page = 1 }) {
    const res = await window.axios.get(`/api/v1/admin/fakeusers/${page}`, { params: condition });
    return res.data;
  }

  async findById({ id }) {
    const res = await window.axios.get('/api/v1/admin/fakeusers/fake', { params: { id } });
    return res.data;
  }

  async update({ body }) {
    const res = await window.axios.put('/api/v1/admin/fakeusers', body);
    return res.data;
  }

  async delete({ id }) {
    const res = await window.axios.delete(`/api/v1/admin/fakeusers?id=${id}`);
    return res.data;
  }

  async create({ body }) {
    const res = await window.axios.post('/api/v1/admin/fakeusers', body);
    return res.data;
  }

  async insert({ body }) {
    const res = await window.axios.post('/api/v1/admin/fakeusers/insert', body);
    return res.data;
  }
}

module.exports = FakeUsers;
